<template lang="pug">
.box
  h4.padding.text-center.m-b-0 Quick Start

  .padding(v-if="filterMode === null")
    .row
      .col-md-8.col-md-push-2
        .list-group.list-group-gap
          a.list-group-item(@click="setFilterMode('all')")
            span.pull-right.text-muted.m-l-xs
              i.glyphicon.glyphicon-chevron-right
            | Add all products from product list
          a.list-group-item(@click="setFilterMode('categories')")
            span.pull-right.text-muted.m-l-xs
              i.glyphicon.glyphicon-chevron-right
            | {{ trans('pricebook.add_products_from_categories') }}
          a.list-group-item(@click="setFilterMode('tags')")
            span.pull-right.text-muted.m-l-xs
              i.glyphicon.glyphicon-chevron-right
            | {{ trans('pricebook.add_products_from_tags') }}
          a.list-group-item(@click="showImport")
            span.pull-right.text-muted.m-l-xs
              i.glyphicon.glyphicon-chevron-right
            | Import from file
          a.list-group-item(@click="showExisting")
            span.pull-right.text-muted.m-l-xs
              i.glyphicon.glyphicon-chevron-right
            | Copy override with existing template

  .padding(v-if="filterMode !== null")
    all-products(v-if="filterMode === 'all'" :pricebook-id="pricebookId" :onCancel="clearFilterMode")
    category-filter(v-if="filterMode === 'categories'" :pricebook-id="pricebookId" :onCancel="clearFilterMode")
    tag-filter(v-if="filterMode === 'tags'" :pricebook-id="pricebookId" :onCancel="clearFilterMode")

</template>

<script>
import { mapGetters } from 'vuex';
import CategoryFilter from './category-filter';
import TagFilter from './tag-filter';
import AllProducts from './all-products';

export default {
    components: {
        CategoryFilter,
        TagFilter,
        AllProducts,
    },

    props: {
        pricebookId: {
            type: Number,
            required: true,
        },
        showImport: {
            type: Function,
            required: true,
        },
        showExisting: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            filterMode: null,
        };
    },

    methods: {
        setFilterMode(mode) {
            this.filterMode = mode;
        },
        clearFilterMode() {
            this.filterMode = null;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/batch/setup-wizard.vue